import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import InputWrapper from '../../../Components/Form/components/InputWrapper/InputWrapper';
import SelectField from '../../../Components/Form/components/SelectField';
import DateField from '../../../Components/Form/components/DateField';
import ScheduleInSpecificDaysInWeekFields from './ScheduleInSpecificDaysInWeekFields';
import { RepeatInterval } from '../Enums/RepeatInterval.enum';
import { SelectValue } from '../../../Components/Base/Select/Select';

interface Props {
	formMethods: UseFormReturn;
}

export const REPEAT_INTERVAL_OPTIONS: SelectValue[] = [
	{ value: RepeatInterval.NEVER, label: 'base.never' },
	{
		value: RepeatInterval.EVERY_WORKING_DAY,
		label: 'component.calendarWorkplaceScheduleEvent.everyWorkingDay',
	},
	{
		value: RepeatInterval.EVERY_WEEK,
		label: 'base.everyWeek',
	},
	{
		value: RepeatInterval.EVERY_MONTH,
		label: 'base.everyMonth',
	},
	{
		value: RepeatInterval.SPECIFIC_DAYS_IN_WEEK,
		label: 'base.specificDaysInWeek',
	},
];

const ScheduleRepeatFields: React.FC<Props> = ({ formMethods }) => {
	const repeatIntervalValue = formMethods.watch('repeatInterval')?.value;
	const hasRepeatTo =
		repeatIntervalValue && repeatIntervalValue !== RepeatInterval.NEVER;

	return (
		<>
			<div className={'row'}>
				<div className={'col-6'}>
					<InputWrapper>
						<SelectField
							label='base.repeat'
							name='repeatInterval'
							isRequired
							options={REPEAT_INTERVAL_OPTIONS}
							portal
						/>
					</InputWrapper>
				</div>
				{hasRepeatTo && (
					<div className={'col-6'}>
						<InputWrapper>
							<DateField
								label='base.repeatTo'
								name='repeatTo'
								isRequired
								usePortal
							/>
						</InputWrapper>
					</div>
				)}
			</div>
			<ScheduleInSpecificDaysInWeekFields text='component.calendarWorkplaceScheduleEvent.selectDayWhenShiftShouldRepeat' />
		</>
	);
};

export default ScheduleRepeatFields;
